const awsconfig = {
  Auth: {
    Cognito: {
        region: "eu-west-1",
        userPoolId: "eu-west-1_6fIhECD36",
        userPoolClientId: "3j74efka8vtuhco8umdme4tdu9",
        }
  },
};
export default awsconfig;
